import Page from "framework/ui/content/Page";
import Head from "framework/ui/content/Head";
import PageContent from "framework/ui/content/PageContent";
import PageSections from "framework/ui/content/PageSections";
import Copyright from "framework/ui/content/Copyright";
import Logo from "framework/ui/content/Logo";
import logo from "./assets/logo.png";

/**
 * @typedef MyPageProps
 *
 * @property {number} [pageId]  Specific page ID to display.
 */

/**
 * Component for site-specific page contents.
 *
 * @param props {MyPageProps}
 * @returns {JSX.Element}
 * @constructor
 */
export default function MyPage(props) {
  return (
    <Page {...props}>
      <Head/>
      <Logo src={logo}/>
      <PageContent>
        <PageSections/>
      </PageContent>
      <Copyright startYear={'2022'}/>
    </Page>
  )
}